var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmergency(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 74,
    viewBox: "0 0 71 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0391 52.7035C11.0391 38.7894 22.3187 27.5098 36.2328 27.5098V67.0194H11.0391V52.7035Z",
    fill: "#C74852"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M61.4102 52.6878C61.4102 38.7824 50.1375 27.5098 36.2321 27.5098V67.0194H61.4102V52.6878Z",
    fill: "#B62A35"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4102 2.64258L35.4102 16.4852",
    stroke: "white",
    strokeWidth: 3.36676,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9922 6.53711L48.4095 19.9081",
    stroke: "white",
    strokeWidth: 3.36676,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8203 6.53711L22.403 19.9081",
    stroke: "white",
    strokeWidth: 3.36676,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1.83984 17.7227L11.6281 27.5109",
    stroke: "white",
    strokeWidth: 3.36676,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9844 17.7227L59.1962 27.5109",
    stroke: "white",
    strokeWidth: 3.36676,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M4.62109 72.6318C4.62109 69.5328 7.13335 67.0205 10.2324 67.0205H62.2199C65.3189 67.0205 67.8311 69.5328 67.8311 72.6318V73.8943H4.62109V72.6318Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmergency);
export default __webpack_public_path__ + "static/media/emergency.57618518172c84c4d2f5768dc843ef68.svg";
export { ForwardRef as ReactComponent };